import React, { Component } from "react";
import { getBookingByRescheduleToken } from "../../actions/bookingAction";
import ErrorPage from "../errors/ErrorPage";
import { connect } from "react-redux";
import {
  withRouter,
  notification,
  getDBFormatedDate,
  computeBookingEndSlot,
} from "../../utils/utility";
import Loader from "../../components/Loader/Loader";
import isEmpty from "../../validation/is-empty";
import { getEvent } from "../../actions/bookingAction";
import { rescheduleEvent } from "../../actions/admin/scheduled-event-actions";
import moment from "moment";
import BookingStep1 from "./booking-step-1";
import BookingStep4 from "./booking-step-4";
import Logo from "../../assets/images/logo-new.svg";
import "./booking-pages.scss";

/* ── Sidebar icons (each distinct, matching screenshot) ──────────── */
const SbCalIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const SbClockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);
const SbGlobeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/>
  </svg>
);
const SbTimerIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 3h14"/><path d="M12 7v8"/><circle cx="12" cy="12" r="7"/>
  </svg>
);
const SbPhoneIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2A19.79 19.79 0 013.07 4.18 2 2 0 015 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);
const SbVideoIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
  </svg>
);
const SbMapIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);
const SbPeopleIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
  </svg>
);
const SbTagIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>
    <line x1="7" y1="7" x2="7.01" y2="7"/>
  </svg>
);

/* ── Venue icon helper ────────────────────────────────────────────── */
const getVenueIcon = (venue) => {
  if (!venue) return <SbVideoIcon />;
  if (venue === "Phone Call")          return <SbPhoneIcon />;
  if (venue === "In-Person Meeting")   return <SbMapIcon />;
  return <SbVideoIcon />; // Google Meet, Zoom, Teams, Others
};

/* ── Component ───────────────────────────────────────────────────── */
class RescheduleBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading:       false,
      step:            1,
      event:           {},
      company:         {},
      selectedStaffId: null,
      selectedSlot:    null,
      endSlotTime:     null,
      bookingDate:     null,
      timezondId:      "",
      timezoneValue:   "",
      specialRibbon:   null,
      error:           null,
      formerData:      null,
    };
  }

  onSelectStaff   = (staffId)                   => this.setState({ selectedStaffId: staffId });
  onSelectTimzone = (timezondId, timezoneValue) => this.setState({ timezondId, timezoneValue });
  onSelectSlot    = (slot)                      => this.setState({ selectedSlot: slot });
  onSelectDate    = (date)                      => this.setState({ bookingDate: getDBFormatedDate(new Date(date)) });

  isInvitee = () => !isEmpty(this.props.router?.params?.time);
  getToken  = () => this.props.router?.params?.token;

  onReschedule = () => {
    this.setState({ isLoading: true });
    const { rescheduleEvent } = this.props;
    const { selectedStaffId, selectedSlot, bookingDate, timezoneValue, event } = this.state;

    const bookingDateTime = bookingDate + " " + selectedSlot;
    const endSlot = computeBookingEndSlot(bookingDate, selectedSlot, event.timeslot, timezoneValue);
    this.setState({ endSlotTime: endSlot });

    const bookingDetails = {
      event_id:          event.id,
      booking_date_time: bookingDateTime,
      start_time:        selectedSlot + ":00",
      end_time:          endSlot      + ":00",
      reschedule_reason: "",
      timezone:          timezoneValue,
      token:             this.getToken(),
      is_invitee:        this.isInvitee() ? "E" : "D",
    };
    if (!isEmpty(selectedStaffId)) bookingDetails.staff_id = selectedStaffId;

    rescheduleEvent({
      data: { ...bookingDetails },
      onSuccess: () => { this.setState({ isLoading: false }); this.setState({ step: 2 }); },
      onError: (error) => {
        this.setState({ isLoading: false });
        notification.error(error?.response?.data?.message || "An error occurred. Please try again.");
      },
    });
  };

  getEventDetails = (bookingData) => {
    const { getEvent } = this.props;
    getEvent({
      data: { slug: bookingData.event_url },
      onSuccess: (response) => {
        const { event, company } = response;
        let selectedStaffId = "";
        if (event.staffs?.length > 0 && event.allow_attendee_select_staff === "E") {
          selectedStaffId = bookingData.host_id;
        }
        this.setState({
          isLoading: false, event, company, selectedStaffId,
          specialRibbon: !isEmpty(response.special_ribbon)
            ? response.special_ribbon.special_announcement : null,
        });
      },
      onError: (error) => {
        this.setState({ isLoading: false, error: "This event is invalid or no longer available" });
        if (error?.response?.data?.message) notification.error(error.response.data.message);
      },
    });
  };

  componentDidMount() {
    const { getBookingByRescheduleToken } = this.props;
    this.setState({ isLoading: true });
    getBookingByRescheduleToken({
      data: { token: this.getToken() },
      onSuccess: (response) => {
        this.setState({ formerData: response });
        if (!isEmpty(response.invitee_timezone)) this.setState({ timezoneValue: response.invitee_timezone });
        if (!isEmpty(response.event_url))        this.getEventDetails(response);
      },
      onError: () => this.setState({ isLoading: false, error: "Invalid token, or token is expired" }),
    });
  }

  render() {
    const {
      step, event, selectedStaffId, selectedSlot, endSlotTime,
      bookingDate, timezoneValue, specialRibbon, isLoading, error, formerData,
    } = this.state;

    if (error) return <ErrorPage message={error} />;

    /* ── Sidebar date/time helpers ─────────────────────────── */
    const sbDate = formerData?.when
      ? moment(formerData.when, "DD-MM-YYYY").format("dddd, MMMM D, YYYY") : "";
    const sbTime = formerData?.start_time
      ? `${moment(formerData.start_time, "HH:mm").format("h:mm A")} – ${moment(formerData.end_time, "HH:mm").format("h:mm A")}` : "";
    const formatLabel = event?.event_format_id === 1
      ? "One on One"
      : (event?.no_of_attendies ? `Group (up to ${event.no_of_attendies})` : "Group");
    const eventTypeLabel = event?.is_event_paid === "E"
      ? `Paid — $${event.event_fee}`
      : "Free";

    return (
      <>
        <Loader isShowLoader={isLoading} />

        <div className="bp-page">
          <div className={`bp-card${step === 1 ? " bp-card--wide" : ""}`}>

            {/* ── Logo ─────────────────────────────────────────── */}
            <div className="bp-logo-bar bp-logo-bar--bordered">
              <img src={Logo} alt="MeetOcto" />
            </div>

            {/* ══════════ STEP 1 — Pick new time ═══════════════════ */}
            {step === 1 && (
              <div className="bp-reschedule-inner">

                {/* ── Left sidebar ─────────────────────────────── */}
                {formerData && (
                  <div className="bp-reschedule-sidebar">
                    <p className="bp-sidebar-label">Current booking</p>
                    <h3 className="bp-sidebar-event">{formerData.event_name}</h3>

                    {/* Time details */}
                    <div className="bp-sidebar-details">
                      <div className="bp-sidebar-row">
                        <SbCalIcon /><span>{sbDate}</span>
                      </div>
                      <div className="bp-sidebar-row">
                        <SbClockIcon /><span>{sbTime}</span>
                      </div>
                      {formerData.invitee_timezone && (
                        <div className="bp-sidebar-row">
                          <SbGlobeIcon /><span>{formerData.invitee_timezone}</span>
                        </div>
                      )}
                      {/* Prefer event.timeslot (clean number from backend), fall back to
                          formerData.event_duration only if event is not yet loaded.
                          The backend returns event_duration as "00 Hours 05 Minutes" which is
                          too verbose; event.timeslot is just "5" so we format it ourselves. */}
                      {(event?.timeslot || formerData.event_duration) && (
                        <div className="bp-sidebar-row">
                          <SbTimerIcon />
                          <span>
                            {!isEmpty(event) && event.timeslot
                              ? (event.timeslot !== "Customized"
                                  ? `${event.timeslot} minutes`
                                  : event.timeslot)
                              : formerData.event_duration}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Event details — from event object */}
                    {!isEmpty(event) && (event.venue || event.event_format_id) && (
                      <>
                        <div className="bp-sidebar-divider" />
                        <div className="bp-sidebar-metas">
                          {event.venue && (
                            <div className="bp-sidebar-meta">
                              <span className="bp-sidebar-meta__label">Venue</span>
                              <span className="bp-sidebar-meta__value">
                                {getVenueIcon(event.venue)}
                                {event.venue}
                              </span>
                            </div>
                          )}
                          <div className="bp-sidebar-meta">
                            <span className="bp-sidebar-meta__label">Format</span>
                            <span className="bp-sidebar-meta__value">
                              <SbPeopleIcon />{formatLabel}
                            </span>
                          </div>
                          <div className="bp-sidebar-meta">
                            <span className="bp-sidebar-meta__label">Event type</span>
                            <span className="bp-sidebar-meta__value">
                              <SbTagIcon />{eventTypeLabel}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* ── Right panel — BookingStep1 ────────────────── */}
                <div className="bp-reschedule-main">
                  {!isEmpty(event) && (
                    <>
                      <div className="bp-rs-header">
                        <h2>Reschedule your booking</h2>
                        <p>Choose a new date and time.</p>
                      </div>
                      <BookingStep1
                        isRescheduleEvent={true}
                        reschedule={this.onReschedule}
                        event={event}
                        bookingStaffId={selectedStaffId}
                        specialRibbon={specialRibbon}
                        initialTimezoneValue={formerData?.invitee_timezone}
                        timezoneValue={timezoneValue}
                        onSelectTimzone={this.onSelectTimzone}
                        onSelectStaff={this.onSelectStaff}
                        onSelectSlot={this.onSelectSlot}
                        onSelectDate={this.onSelectDate}
                      />
                    </>
                  )}
                </div>
              </div>
            )}

            {/* ══════════ STEP 2 — Confirmed ═══════════════════════ */}
            {step === 2 && (
              <>
                <div className="bp-confirmed">
                  <div className="bp-confirmed-icon bp-confirmed-icon--success">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  </div>
                  <h2 className="bp-confirmed-title">Reschedule Confirmed</h2>
                  <p className="bp-confirmed-sub">Your booking has been successfully rescheduled.</p>
                  <div style={{ textAlign: "left", marginTop: 8 }}>
                    <BookingStep4
                      specialRibbon={specialRibbon}
                      timezoneValue={timezoneValue}
                      event={event}
                      selectedSlot={selectedSlot}
                      endSlotTime={endSlotTime}
                      bookingDate={bookingDate}
                      guests={[]}
                    />
                  </div>
                </div>
                <div className="bp-footer">
                  <span>Powered by</span>
                  <img src={Logo} alt="MeetOcto" />
                </div>
              </>
            )}

          </div>
        </div>
      </>
    );
  }
}

export default connect(null, {
  getBookingByRescheduleToken,
  getEvent,
  rescheduleEvent,
})(withRouter(RescheduleBooking));
